<script>
import Layout from "../../layouts/main";
// import PageHeader from "@/components/page-header";
/* Dashboard component */
// import CircleChart from "./CircleChart.vue";
// import GaugeChart from "./GaugeChart.vue";
// import MyGaugeChart from "./GaugeEchart.vue";
// import Orders from "./dashboard_comp/Orders.vue";
// import Revenue from "./dashboard_comp/Revenue.vue";
// import Cancellations from "./dashboard_comp/Cancellations.vue";
// import Complaints from "./dashboard_comp/Complaints.vue";
// import OutOfStock from "./dashboard_comp/OutOfStock.vue";
// import OrdersGraph from "./dashboard_comp/graphs/OrdersGraph.vue";
// import RevenueGraph from "./dashboard_comp/graphs/RevenueGraph.vue";
// import CancellationsGraph from "./dashboard_comp/graphs/CancellationsGraph.vue";
// import VisibilityGraph from "./dashboard_comp/graphs/VisibilityGraph.vue";
// import Kpt from "./dashboard_comp/Kpt.vue";
// import Visibility from "./dashboard_comp/Visibility.vue";
// import RepeatCustomers from "./dashboard_comp/RepeatCustomers.vue";
// import ComplaintsGraph from "./dashboard_comp/graphs/ComplaintsGraph.vue";
// import KptGraph from "./dashboard_comp/graphs/KptGraph.vue";
// import OutOfStockGraph from "./dashboard_comp/graphs/OutOfStockGraph.vue";
import { DASHBOARD_PATH, RestaurantsPath, USERSPATH } from "../../../path";
// import SelectWithSearch from "../Dilfoods/Common/SelectWithSearch.vue";
import axios from "axios";
export default {
  components: {
    Layout,
    // PageHeader,
    // CircleChart,
    // MyGaugeChart,
    // Orders,
    // Revenue,
    // Visibility,
    // Cancellations,
    // Kpt,
    // RepeatCustomers,
    // Complaints,
    // OutOfStock,
    // OrdersGraph,
    // RevenueGraph,
    // VisibilityGraph,
    // CancellationsGraph,
    // ComplaintsGraph,
    // KptGraph,
    // OutOfStockGraph,
    // SelectWithSearch,
  },
  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "DilFoods",
        },
        {
          text: "Dashboard",
          active: true,
        },
      ],
      showGraphs: false,
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      base_node_url: process.env.VUE_APP_API_BACKEND_NODE_URL,
      graph: null,
      selected: null,
      options: [
        { value: null, text: "Last 7 Days" },
        { value: 1, text: "Today" },
        { value: 2, text: "Yesterday" },
        { value: 7, text: "Last 7 Days" },
        { value: 30, text: "Last 30 Days" },
      ],
      slot: null,
      dreamRevenuePer: 0,
      dreamRevSet: false,
      reset: false,
      restaurant: {
        id: 14,
        name: "Dil Central Facility",
      },
      rating: null,
      showImpersonateModal: false,
      impersonateSearch: "",
      impersonateResults: [],
      impersonateUser: null,
      impersonateLoading: false,
      impersonateSearchLoading: false,
    };
  },
  watch: {
    restaurant: {
      handler(newVal, oldVal) {
        if (newVal.id !== oldVal.id) {
          this.getRating();
        }
      },
      deep: true,
    },
  },
  computed: {
    RestaurantsPath() {
      return RestaurantsPath;
    },
  },
  mounted() {
    console.log(this.$store.state.authfack, "AUTH");
    // this.getRestaurants();
    // this.getRating();
  },
  methods: {
    // async getRestaurants() {
    //   try {
    //     let response = await axios.get(
    //       this.base_url + RestaurantsPath.BASIC_RESTAURENT,
    //       {
    //         params: {
    //           page: 1,
    //           search: 'chenn',
    //         },
    //       }
    //     );
    //     if (response.data.status == true) {
    //       console.log(response,'res');
    //     }
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
    async getRating() {
      try {
        let res = await axios.get(this.base_node_url + DASHBOARD_PATH.RATING, {
          params: {
            resId: this.$store.state.authfack.user.restaurant
              ? this.$store.state.authfack.user.restaurant.id
              : this.restaurant.id,
          },
        });
        if (res.data.status == true) {
          this.rating = Math.round(res.data.rating);
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleChangeRevenue(value, max, rev) {
      this.dreamRevSet = true;
      this.reset = false;
      if (rev < 100000) {
        this.dreamRevenuePer = (((value * 1000) / rev) * 100).toFixed(0);
      } else {
        this.dreamRevenuePer = (((value * 100000) / rev) * 100).toFixed(0);
      }
      value = Math.floor(value);

      const ratio = value / max;

      if (ratio > 0.75) {
        this.slot = 4;
      } else if (ratio > 0.5) {
        this.slot = 3;
      } else if (ratio > 0.25) {
        this.slot = 2;
      } else {
        this.slot = 1;
      }
    },
    isSuperAdmin() {
      return (
        this.$store.state.authfack.user &&
        this.$store.state.authfack.user.roles.filter(
          (f) => f.name == "SuperAdmin"
        ).length > 0
      );
    },
    async searchImpersonateUsers(query) {
      this.impersonateSearch = query;
      if (query.length < 2) {
        this.impersonateResults = [];
        return;
      }
      this.impersonateSearchLoading = true;
      try {
        const response = await axios.get(
          this.base_url + USERSPATH.GET_ACCOUNTMANAGET_USERS,
          { params: { search: query } }
        );
        const users = response.data?.data?.data || response.data?.data || [];
        this.impersonateResults = Array.isArray(users) ? users : [];
      } catch {
        this.impersonateResults = [];
      } finally {
        this.impersonateSearchLoading = false;
      }
    },
    selectImpersonateUser(user) {
      this.impersonateUser = user;
      this.impersonateSearch = "";
      this.impersonateResults = [];
    },
    removeImpersonateUser() {
      this.impersonateUser = null;
    },
    closeImpersonateModal() {
      this.showImpersonateModal = false;
      this.impersonateSearch = "";
      this.impersonateResults = [];
      this.impersonateUser = null;
    },
    async handleImpersonate() {
      if (!this.impersonateUser) return;
      this.impersonateLoading = true;
      try {
        const response = await axios.post(
          this.base_url + USERSPATH.IMPERSONATE,
          { user_id: this.impersonateUser.id }
        );
        if (response.data.status) {
          const data = response.data.data;
          localStorage.setItem("user", JSON.stringify(data));
          localStorage.setItem("token", JSON.stringify(data.token));
          window.location.href = "/";
        } else {
          alert(response.data.message || "Failed to impersonate");
        }
      } catch (err) {
        alert(
          (err.response && err.response.data && err.response.data.message) ||
            "Failed to impersonate"
        );
      } finally {
        this.impersonateLoading = false;
      }
    },
    resetDreamRevenue() {
      this.slot = null;
      this.dreamRevenuePer = 0;
      this.dreamRevSet = false;
      this.reset = true;
    },
    handleSetGraph(graphName) {
      this.graph = graphName;
      if (this.showGraphs) {
        this.showGraphs = false;
      } else {
        this.showGraphs = true;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div>
      <PageHeader :title="title" :items="items" />
      <p
        @click="isSuperAdmin() ? showImpersonateModal = true : null"
      >Welcome to Dil Foods !</p>
    </div>

    <!-- Impersonate Modal (SuperAdmin only) -->
    <div v-if="showImpersonateModal && isSuperAdmin()" class="impersonate-overlay" @click.self="closeImpersonateModal()">
      <div class="impersonate-modal">
        <div class="impersonate-modal-header">
          <h4 class="impersonate-title">Login as User</h4>
          <span class="impersonate-modal-close" @click="closeImpersonateModal()">&times;</span>
        </div>
        <p class="impersonate-modal-desc">Impersonate a user for testing purposes</p>
        <div class="impersonate-search-wrapper">
          <input
            type="text"
            placeholder="Search user by name or email"
            :value="impersonateSearch"
            @input="searchImpersonateUsers($event.target.value)"
            class="impersonate-input"
          />
          <div v-if="impersonateSearchLoading" class="impersonate-spinner"></div>
          <div
            v-if="impersonateResults.length > 0 && !impersonateUser"
            class="impersonate-dropdown"
          >
            <button
              v-for="u in impersonateResults"
              :key="u.id"
              class="impersonate-dropdown-item"
              @click="selectImpersonateUser(u)"
            >
              <span class="impersonate-user-name">{{ u.name }}</span>
              <span class="impersonate-user-email ml-2">{{ u.email }}</span>
            </button>
          </div>
        </div>
        <div v-if="impersonateUser" class="impersonate-selected">
          <div>
            <span class="impersonate-user-name">{{ impersonateUser.name }}</span>
            <span class="impersonate-user-email ml-2">{{ impersonateUser.email }}</span>
          </div>
          <button class="impersonate-remove" @click="removeImpersonateUser()">Remove</button>
        </div>
        <button
          v-if="impersonateUser"
          class="impersonate-btn"
          :disabled="impersonateLoading"
          @click="handleImpersonate()"
        >
          {{ impersonateLoading ? "Logging in..." : "Login as User" }}
        </button>
      </div>
    </div>

    <!-- <div
      v-if="
        $store.state.authfack.user.roles.filter((f) => f.name == 'SuperAdmin')
          .length > 0 ||
        $store.state.authfack.user.roles.filter((f) => f.name == 'SubAdmin')
          .length > 0 ||
        $store.state.authfack.user.roles.filter(
          (f) => f.name == 'AccountManagers'
        ).length > 0
      "
    >
      <div style="display: flex; justify-content: space-between">
        <div>
          <div
            style="
              width: max-content;
              display: flex;
              gap: 10px;
              align-items: center;
              margin-top: 10px;
            "
          >
            <p
              style="
                font-weight: 900;
                padding-block: 10px;
                font-size: 24px;
                font-family: Georgia, 'Times New Roman', Times, serif;
              "
            >
              {{
                $store.state.authfack.user.restaurant
                  ? $store.state.authfack.user.restaurant.name
                  : restaurant.name
              }}
            </p>
            <div
              style="
                padding-inline: 8px;
                padding-block: 1px;
                background-color: green;
                font-weight: 600;
                color: white;
                border-radius: 6px;
                display: flex;
                align-items: center;
              "
            >
              <p style="">{{ rating }}</p>
              <i
                class="fa fa-star"
                style="font-size: 10px; margin-left: 3px"
              ></i>
            </div>
          </div>
          <div
            style="display: flex; align-items: end; gap: 40px"
            v-if="!showGraphs"
          >
            <div>
              <b-form-select
                v-model="selected"
                :options="options"
              ></b-form-select>
            </div>
            <div
              style="margin-block: 10px"
              v-if="
                $store.state.authfack.user.roles.filter(
                  (f) => f.name == 'RestaurantPartner'
                ).length > 0
              "
            >
              <a href="/#/tickets_dashboard">
                <b-button variant="primary">Raise/Track Tickets </b-button>
              </a>
            </div>
            <div style="width: 500px">
              <b-row>
                <b-col sm="6">
                  <label>Search Restaurant</label>
                  <SelectWithSearch
                    :search_api="RestaurantsPath.GET_RESTAURANTS"
                    track_by="id"
                    display="name"
                    full_object="true"
                    @selectedOption="(v) => (restaurant = v)"
                  ></SelectWithSearch>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <div style="display: flex; position: relative" v-if="!showGraphs">
          <p
            v-if="dreamRevSet"
            style="position: absolute; z-index: 10; left: -40px; top: 20px"
          >
            <b-button
              variant="outline-primary"
              style="border-radius: 10px; padding: 4px; padding-inline: 10px"
              @click="resetDreamRevenue()"
              >Reset to current</b-button
            >
          </p>
          <div style="width: 400px">
            <MyGaugeChart
              @changeRevenue="handleChangeRevenue"
              :reset="reset"
              :restaurant="restaurant"
            />
            <h3
              v-if="!dreamRevSet"
              style="text-align: center; margin-top: -25px"
            >
              Current Revenue
            </h3>
            <h3
              v-if="dreamRevSet"
              style="text-align: center; margin-top: -25px"
            >
              Dream Revenue
            </h3>
          </div>
        </div>
      </div>
      <div v-if="!showGraphs">
        <div>
          <h4 style="font-weight: 400">Bussiness Metrics</h4>
          <div
            style="
              display: grid;
              justify-content: space-between;
              flex-wrap: wrap;
              cursor: default;
              gap: 10px;
            "
            class="bussiness-container"
          >
            <Orders
              :days="selected"
              :slot="slot"
              :dreamRevenuePer="dreamRevenuePer"
              :dreamRevSet="dreamRevSet"
              @setGraph="handleSetGraph"
              :restaurant="restaurant"
            />
            <Revenue
              :days="selected"
              :slot="slot"
              :dreamRevenuePer="dreamRevenuePer"
              :dreamRevSet="dreamRevSet"
              @setGraph="handleSetGraph"
              :restaurant="restaurant"
            />
            <Visibility
              :days="selected"
              :slot="slot"
              :dreamRevenuePer="dreamRevenuePer"
              :dreamRevSet="dreamRevSet"
              @setGraph="handleSetGraph"
              :restaurant="restaurant"
            />
            <Cancellations
              :days="selected"
              :slot="slot"
              :dreamRevenuePer="dreamRevenuePer"
              :dreamRevSet="dreamRevSet"
              @setGraph="handleSetGraph"
              :restaurant="restaurant"
            />
          </div>
        </div>
        <div>
          <h4 style="font-weight: 400; margin-top: 20px">
            Operational Metrics
          </h4>
          <div
            style="
              display: grid;
              grid-template-columns: repeat(4, 1fr);
              gap: 10px;
            "
          >
            <Complaints
              :days="selected"
              :slot="slot"
              :dreamRevenuePer="dreamRevenuePer"
              :dreamRevSet="dreamRevSet"
              @setGraph="handleSetGraph"
              :restaurant="restaurant"
            />
            <div
              style="
                background-color: #e5ecf6;
                color: white;
                padding: 10px;
                border-radius: 3px;
              "
            >
              <div>
                <div style="color: black; display: flex">
                  <div style="width: 45%">
                    <div style="transform: scale(1.5)">
                      <CircleChart color="#3DA3CA" percentage="75" />
                    </div>
                  </div>
                  <div style="flex: 1">
                    <p
                      style="
                        color: rgb(60, 60, 60);
                        letter-spacing: 1px;
                        font-size: 34px;
                        font-weight: 900;
                        text-align: center;
                      "
                    >
                      75%
                    </p>
                    <p
                      style="
                        color: rgb(50, 50, 50);
                        letter-spacing: 1px;
                        font-size: 20px;
                        font-weight: 400;
                        text-align: center;
                      "
                    >
                      MFR
                    </p>
                  </div>
                </div>
              </div>
              <p style="color: #90ca4b; font-weight: 900; text-align: center">
                <span style="font-size: 16px">
                  <i class="fa fa-caret-up" style="color: #90ca4b"></i> 10%
                </span>
                <span style="color: rgb(60, 60, 60); font-weight: 400"
                  >compare to previous 7 days</span
                >
              </p>
            </div>
            <Kpt
              :days="selected"
              :slot="slot"
              :dreamRevenuePer="dreamRevenuePer"
              :dreamRevSet="dreamRevSet"
              @setGraph="handleSetGraph"
              :restaurant="restaurant"
            />
            <RepeatCustomers
              :days="selected"
              :slot="slot"
              :dreamRevenuePer="dreamRevenuePer"
              :dreamRevSet="dreamRevSet"
              @setGraph="handleSetGraph"
              :restaurant="restaurant"
            />
            <OutOfStock
              :days="selected"
              :slot="slot"
              :dreamRevenuePer="dreamRevenuePer"
              :dreamRevSet="dreamRevSet"
              @setGraph="handleSetGraph"
              :restaurant="restaurant"
            />
          </div>
        </div>
      </div>
      <div v-if="graph == 'orders'">
        <OrdersGraph @setGraph="handleSetGraph" :restaurant="restaurant" />
      </div>
      <div v-if="graph == 'revenue'">
        <RevenueGraph @setGraph="handleSetGraph" :restaurant="restaurant" />
      </div>
      <div v-if="graph == 'cancellations'">
        <CancellationsGraph
          @setGraph="handleSetGraph"
          :restaurant="restaurant"
        />
      </div>
      <div v-if="graph == 'visibility'">
        <VisibilityGraph @setGraph="handleSetGraph" :restaurant="restaurant" />
      </div>
      <div v-if="graph == 'complaints'">
        <ComplaintsGraph @setGraph="handleSetGraph" :restaurant="restaurant" />
      </div>
      <div v-if="graph == 'kpt'">
        <KptGraph @setGraph="handleSetGraph" :restaurant="restaurant" />
      </div>
      <div v-if="graph == 'outofstock'">
        <OutOfStockGraph @setGraph="handleSetGraph" :restaurant="restaurant" />
      </div>
    </div> -->
  </Layout>
</template>

<style>
.impersonate-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.impersonate-modal {
  background: white;
  border-radius: 10px;
  padding: 24px;
  width: 400px;
  max-width: 90vw;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}
.impersonate-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.impersonate-modal-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.impersonate-modal-close {
  font-size: 24px;
  cursor: pointer;
  color: #999;
  line-height: 1;
}
.impersonate-modal-close:hover {
  color: #333;
}
.impersonate-modal-desc {
  font-size: 13px;
  color: #888;
  margin-bottom: 16px !important;
}
.impersonate-search-wrapper {
  position: relative;
}
.impersonate-input {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 8px 12px;
  font-size: 13px;
  outline: none;
  box-sizing: border-box;
}
.impersonate-input:focus {
  border-color: #f59e0b;
}
.impersonate-spinner {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 16px;
  height: 16px;
  border: 2px solid #f59e0b;
  border-top-color: transparent;
  border-radius: 50%;
  animation: imp-spin 0.6s linear infinite;
}
@keyframes imp-spin {
  to { transform: rotate(360deg); }
}
.impersonate-dropdown {
  position: absolute;
  z-index: 100;
  width: 100%;
  background: white;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-top: 2px;
  max-height: 180px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}
.impersonate-dropdown-item {
  width: 100%;
  text-align: left;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 13px;
  display: block;
  border: none;
  background: none;
}
.impersonate-dropdown-item:hover {
  background-color: #f5f5f5;
}
.impersonate-user-name {
  font-weight: 600;
  font-size: 13px;
  color: #333;
}
.impersonate-user-email {
  font-size: 12px;
  color: #888;
}
.impersonate-selected {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fffbeb;
  padding: 8px 12px;
  border-radius: 5px;
  margin-top: 8px;
  border: 1px solid #fde68a;
}
.impersonate-remove {
  color: #ef4444;
  cursor: pointer;
  font-size: 13px;
  background: none;
  border: none;
  padding: 0;
}
.impersonate-remove:hover {
  color: #dc2626;
}
.impersonate-btn {
  margin-top: 8px;
  padding: 8px 16px;
  background: #f59e0b;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.impersonate-btn:hover {
  background: #d97706;
}
.impersonate-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.card-hover {
  transition: all 0.2s;
}
.card-hover:hover {
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px,
    rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
  transition: all 0.2s;
}
.bussiness-container {
  grid-template-columns: repeat(1, 1fr);
}

@media (min-width: 576px) {
  .bussiness-container {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
